import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import editCustomTestingProceduresDialog from './dialog.editCustomTestingProceduresDialog';
import controller from './custom-testing-procedure.controller';
import directive from './custom-testing-procedure.directive';

export default angular.module('app.components.advisory.bcp.customTestingProcedure', [
  bcpDataService,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editCustomTestingProceduresDialog,
  ssListItem,
])
  .directive('bcpCustomTestingProcedure', directive)
  .controller('CustomTestingProcedureController', controller)
  .name;

console.log('app.components.advisory.bcp.customTestingProcedure created');
